import React, {createContext, Component} from 'react';
import webRootContext from "../components/webrootcontext/WebRootContext";

export const AppConfiguration = createContext();

/**
 * AppConfigProvider is used for storing application configuration parameters in the app context
 * 
 * To Access: 
 		import {AppConfiguration} from "../framework/AppConfigProvider";
 		const localConfig = useContext(AppConfiguration);
 		// Acess property via localConfig.configProperties.PROPERTYNAME
 	
 */
class AppConfigProvider extends Component {
   
	state = {configProperties: { }};
    
    componentDidMount() {
   		
   		let propertiesURL = 	webRootContext + "/rest/properties"; 
        
        fetch(propertiesURL, {mode:"no-cors"})  //CALLS THE USERPROFILE SERVICE SUCCESSFULLY
          .then((response) => response.json())
          .then( (data) => {      
			 console.log("We properly ran service. setting state for ", data);
             this.setState({configProperties: data});
            
            }, 
            (error) => {
      		  console.log("Error getting Application configuration!", error);
              this.setState({isLoaded: true, error });
              
          });     
    }
            
    render() {
                  
          return (
	          <AppConfiguration.Provider value={{...this.state}} webRootContext={webRootContext}>
	            {this.props.children}
	          </AppConfiguration.Provider>
          )
    }
}

export default AppConfigProvider;